<template lang="">
  <div class="modal_wrap">
    <div class="modal">
        <a @click="closeModal" class="modal_close"></a>
        <div class="modal_header">
            <div class="title">로그인</div>
            <p class="txt">로그인하시면 다양한 혜택을 누리실 수 있습니다.</p>
        </div>
        <div class="modal_body">
            <div class="member">
                <div class="form_wrap">
                    <p class="title">아이디</p>
                    <input type="text" placeholder="아이디를 입력해주세요.">
                </div>
                <div class="form_wrap">
                    <p class="title">비밀번호</p>
                    <input type="password" placeholder="비밀번호를 입력해주세요.">
                </div>
                <div class="find_wrap">
                    <div class="chk_wrap">
                        <input type="checkbox" id="save" name="save">
                        <label for="save" class="chk_btn">
                            <span>아이디 저장</span>
                        </label>
                    </div>
                    <div class="find_box">
                        <a href="">아이디 찾기</a>
                        <a href="">비밀번호 찾기</a>
                        <a href="">회원가입</a>
                    </div>
                </div>
                <button type="button" class="btn_login">로그인</button>
                <button type="button" class="btn_NonMember">비회원 입장하기</button>
                <div class="simple">
                    <div class="btn_wrap">
                        <button type="button" class="kakao">
                            카카오로 시작하기
                        </button>
                        <button type="button" class="naver">
                            네이버로 시작하기
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    closeModal() {
      this.$emit('closeModal')
    }
  }
}
</script>
<style lang="">
    
</style>